import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Button, Box } from '@mui/material';
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import ItemProductReportPreview from '../components/ItemProductReportPreview.js';

const ItemProductsReportPage = () => {

    const { userRole } = useAuth()
    const [employee, setEmployee] = useState(true);
    const [popupData, setPopupData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [previewType, setpreviewType] = useState("item");

    const togglePopup = (rowData,type) => {
        setShowPopup(!showPopup);
        setPopupData(rowData);
        setpreviewType(type)
    };

    useEffect(() => {
        if (userRole === "manager") {
            setEmployee(false)
        } else {
            setEmployee(true)
        };
    }, [userRole])

    const [itemData, setItemData] = useState([]);
    const [productData, setProductData] = useState([]);

    useEffect(() => {
        const fetchAllProducts = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/products/all_products`)
                const responseData = await response.json();
                setProductData(responseData.product);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }

        const fetchAllItemServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/itemservices/all_itemservices`)
                const responseData = await response.json();
                const itemData = responseData.itemservice.filter(item => item.type === "Item");
                setItemData(itemData);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }

        fetchAllProducts();
        fetchAllItemServices();
    }, [])

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id', //access nested data with dot notation
                header: 'Item Id',
                size: 100,
            },
            {
                accessorKey: 'itemservice', //access nested data with dot notation
                header: 'Item name',
                size: 100,
            },
            {
                accessorKey: 'currentstock', //normal accessorKey
                header: 'Current Stock',
                size: 200,
            },
            {
                accessorKey: 'vendor_name',
                header: 'Vendor',
                size: 100,
                Cell: ({ cell }) => (
                    `${cell.getValue() ? cell.getValue() : "Unavailable"}`
                )
            },
            {
                header: 'Report',
                size: 200,
                Cell: ({ cell }) => (
                    <Box display="flex" alignItems="center" gap="18px">
                        <Button
                            variant="contained"
                            onClick={() => togglePopup(cell.row.original,"item")}
                            sx={{ backgroundColor: '#5932EA', borderRadius: '10px', px: '10px', py: '4px', color: 'white', fontSize: '14px' }}
                        >
                            Generate Report
                        </Button>
                    </Box>
                ),
            },
        ],
        [],
    );

    const columns2 = useMemo(
        () => [
            {
                accessorKey: 'product_name', //access nested data with dot notation
                header: 'Product name',
                size: 100,
            },
            // {
            //     accessorKey: 'product_quantity', //normal accessorKey
            //     header: 'Current Stock',
            //     size: 200,
            // },
            // {
            //     accessorKey: 'product_rate',
            //     header: 'Sale Rate',
            //     size: 100,
            // },
            {
                header: 'Report',
                size: 200,
                Cell: ({ cell }) => (
                    <Box display="flex" alignItems="center" gap="18px">
                        <Button
                            variant="contained"
                            onClick={() => togglePopup(cell.row.original,"product")}
                            sx={{ backgroundColor: '#5932EA', borderRadius: '10px', px: '10px', py: '4px', color: 'white', fontSize: '14px' }}
                        >
                            Generate Report
                        </Button>
                    </Box>
                ),
            },
        ],
        [],
    );

    return (
        <>
            <StickyTitle title="Item & Product Reports" no_button={true} />
            <div className='px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
                <div className="table-filters flex flex-row items-center justify-between mb-5">
                    <div className='text-2xl font-bold font-poppins'>Items</div>
                </div>

                {itemData && (<div className="w-ful mb-10">
                    <MaterialReactTable
                        columns={columns}
                        data={itemData}
                        renderTopToolbarCustomActions={({ table }) => {
                            return (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <Button
                                        color="success"
                                        variant="contained"
                                    >
                                        <CSVLink data={itemData}>Export to CSV</CSVLink>
                                    </Button>
                                </div>
                            );
                        }}
                    />
                </div>)}

                <div className="table-filters flex flex-row items-center justify-between mb-5">
                    <div className='text-2xl font-bold font-poppins'>Products</div>
                </div>

                {productData && (<div className="w-full">
                    <MaterialReactTable
                        columns={columns2}
                        data={productData}
                        renderTopToolbarCustomActions={({ table }) => {
                            return (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <Button
                                        color="success"
                                        variant="contained"
                                    >
                                        <CSVLink data={productData}>Export to CSV</CSVLink>
                                    </Button>
                                </div>
                            );
                        }}
                    />
                </div>)}

                {showPopup && (
                    <div className="fixed bg-white inset-0 flex items-center overflow-y-auto justify-center z-50">
                        <div className="bg-white rounded-lg p-4 shadow-md ">
                            <button
                                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                                onClick={togglePopup}
                            >
                                <svg
                                    className="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                            <div style={{
                                height: '90vh',
                                overflowY: 'auto',
                            }}>
                                <ItemProductReportPreview reportType={previewType} rowData={popupData} />
                            </div>
                        </div>
                    </div >
                )}

            </div>
        </>
    );
};

export default ItemProductsReportPage;
